// extracted by mini-css-extract-plugin
module.exports = {"iconWithText":"iconWithText-module--iconWithText--1dnuX","icon":"iconWithText-module--icon--169nQ","invisible":"iconWithText-module--invisible--1FcWu"};